import styled from 'styled-components';

export const StyledWorksWith = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 10px;
  font-size: 13px;
  color: #303030;
  flex-wrap: wrap;
`;

export const StyledAvatarStack = styled.div`
  display: inline-flex;
  padding-top: 2px;
  flex-shrink: 0;
  & > div {
    margin-left: -6px;
    border: 2px solid #fff;
  }
  & > div:first-child {
    margin-left: 0;
  }
`;
